import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AddSpaceRecordsToCluster(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $spaceRecordIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                addSpaceRecordsToCluster(
                  clusterId: $clusterId
                  spaceRecordIds: $spaceRecordIds
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AddSpaceRecordsToClusterMutation,
  undefined,
  graphql.schema.AddSpaceRecordsToClusterMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
